import * as React from 'react';
import { useSelector } from 'react-redux';
import { betreuerByNrSelector, lookupsLoadingFinishedSelector } from 'store/lookups/selector';
import { useBetreuerWorkMonthList } from 'api/betreuerWorkMonth';
import { hoursToTimeString, minutesToTimeString } from 'utils/time';
import classnames from 'classnames';
import { formStyles } from 'styles/formStyles';
import moment from 'moment-timezone';
import { styles } from '../arbeitszeit/Arbeitszeit';

interface ArbeitszeituebersichtProps {
    workYear: number;
    workMonth: number;
    printView?: boolean;
}

export const Arbeitszeituebersicht: React.FC<ArbeitszeituebersichtProps> = ({
    workYear,
    workMonth,
    printView = false,
}) => {
    const lookupsLoadingFinished = useSelector(lookupsLoadingFinishedSelector);
    const betreuerByNr = useSelector(betreuerByNrSelector);

    const betreuerWorkMonthList = useBetreuerWorkMonthList({ workYear, workMonth });

    if (!lookupsLoadingFinished) {
        return <div />;
    }

    const textClassNameHead = classnames(
        styles.tdHead,
        printView ? formStyles.reportTimePrintCell : formStyles.reportTimeCell,
    );

    const textClassNameBody = classnames(
        styles.tdBody,
        printView ? formStyles.reportTimePrintCell : formStyles.reportTimeCell,
    );

    const summaryClassNameHead = classnames(
        styles.tdHead,
        formStyles.dataValueCenter,
        printView ? formStyles.reportSummaryPrintCell : formStyles.reportSummaryCell,
    );

    const summaryClassNameBody = classnames(
        styles.tdBody,
        formStyles.dataValueCenter,
        printView ? formStyles.reportSummaryPrintCell : formStyles.reportSummaryCell,
    );

    return (
        <div className={printView ? styles.printContainer : styles.container}>
            <h1>
                Arbeitszeiten Monat {workYear}-{workMonth.toString().padStart(2, '0')}
            </h1>
            {printView && (
                <table className={formStyles.reportFilterInfo}>
                    <tr>
                        <td>Druckdatum: </td>
                        <td>{moment().format('DD.MM.YYYY HH:mm:ss')}</td>
                    </tr>
                </table>
            )}
            <table className={styles.summaryTable}>
                <thead>
                    <tr>
                        <td className={textClassNameHead}>Name</td>
                        <td className={summaryClassNameHead}>
                            Urlaub
                            <br />
                            Vormonat
                        </td>
                        <td className={summaryClassNameHead}>
                            Urlaub
                            <br />
                            Anpassung
                        </td>
                        <td className={summaryClassNameHead}>
                            Urlaub
                            <br />
                            Aktuell
                        </td>
                        <td className={summaryClassNameHead}>
                            Überstunden
                            <br />
                            Vormonat
                        </td>
                        <td className={summaryClassNameHead}>
                            Überstunden
                            <br />
                            Anpassung
                        </td>
                        <td className={summaryClassNameHead}>
                            Überstunden
                            <br />
                            Aktuell
                        </td>
                        <td className={summaryClassNameHead}>
                            Stunden
                            <br />
                            Soll
                            <br />
                        </td>
                        <td className={summaryClassNameHead}>
                            Stunden
                            <br />
                            Ist
                            <br />
                        </td>
                        <td className={summaryClassNameHead}>Anmerkung</td>
                    </tr>
                </thead>
                <tbody>
                    {(betreuerWorkMonthList.data || []).map((betreuerWorkMonth) => (
                        <tr key={betreuerWorkMonth.betrNr}>
                            <td className={textClassNameBody}>
                                {betreuerWorkMonth?.betrNr ? betreuerByNr[betreuerWorkMonth?.betrNr]?.name : '?'}
                            </td>
                            <td className={summaryClassNameBody}>
                                {hoursToTimeString(betreuerWorkMonth?.holidayHoursPrior, true)}
                            </td>
                            <td className={summaryClassNameBody}>
                                {hoursToTimeString(betreuerWorkMonth?.holidayHoursNew, true)}
                            </td>
                            <td className={summaryClassNameBody}>
                                {hoursToTimeString(betreuerWorkMonth?.holidayHoursCurrent, true)}
                            </td>
                            <td className={summaryClassNameBody}>
                                {hoursToTimeString(betreuerWorkMonth?.overtimeHoursPrior, true)}
                            </td>
                            <td className={summaryClassNameBody}>
                                {hoursToTimeString(betreuerWorkMonth?.overtimeHoursNew, true)}
                            </td>
                            <td className={summaryClassNameBody}>
                                {hoursToTimeString(betreuerWorkMonth?.overtimeHoursCurrent, true)}
                            </td>
                            <td className={summaryClassNameBody}>
                                {minutesToTimeString(betreuerWorkMonth?.planTotal, true)}
                            </td>
                            <td className={summaryClassNameBody}>
                                {minutesToTimeString(betreuerWorkMonth?.actualTotal, true)}
                            </td>
                            <td className={summaryClassNameBody}>{betreuerWorkMonth?.note}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
